import { DragOverlay } from '@dnd-kit/core'
import React, { PropsWithChildren } from 'react'
import { createPortal } from 'react-dom'

interface DragOverlayPortalProps extends PropsWithChildren {
  dropAnimation?: any
  className?: string
}

const DragOverlayPortal = ({ children, dropAnimation, className }: DragOverlayPortalProps) => {
  return createPortal(
    <DragOverlay dropAnimation={dropAnimation} className={className}>
      {children}
    </DragOverlay>,
    document.body,
  )
}

export default DragOverlayPortal
